module.exports = __webpack_public_path__ + "img/pexels-pixabay-158827.0c5ca270.jpg";